import getApiBaseUrl from "./getApiBaseUrl";
export const fetchPageData = async (
  endpoint,
  method,
  errorMessage,
  token,
  payload
) => {
  const options = {
    method: method,
    headers: {
      "Content-Type": "application/json",
    },
  };
  if (method !== "GET") {
    options.headers["Authorization"] = "Bearer " + token;
    options.body = JSON.stringify(payload);
  }

  try {
    // console.log(`${BASE_URl("http")}/${endpoint}`);
    const response = await fetch(
      `${getApiBaseUrl("http")}/${endpoint}`,
      options
    );
    if (response.status === 422) {
      throw new Error("Validation failed.");
    }
    if (response.status !== 200 && response.status !== 201) {
      throw new Error(errorMessage);
    }

    const data = await response.json();

    return { data: data, error: null };
  } catch (err) {
    return { data: null, error: err };
  }
};

//   console.log(resData);

//   // const updatedContact = resData.contact;
//   const service = {
//     _id: resData.service._id,
//     serviceName: resData.service.serviceName,
//     description: resData.service.description,
//   };

//   this.setState((prevState) => {
//     // console.log(prevState.contacts.concat(contact));
//     let updatedServices;
//     console.log(prevState.services.concat(service));
//     if (prevState.editService) {
//       updatedServices = prevState.services.map((c) =>
//         c._id === service._id ? service : c
//       );
//     } else {
//       console.log(prevState.services.concat(service));

//       updatedServices = prevState.services.concat(service);
//     }
//     return {
//       services: updatedServices,
//       isEditing: false,
//       editService: null,
//       // editLoading: false,
//     };
//   });
// })
// .catch((err) => {
//   console.log(err);
//   this.setState({
//     isEditing: false,
//     editService: null,
//     // editLoading: false,
//     error: err,
//   });
// });
